import { createContext, useContext } from "react";

/**
 * True while the Builder is view-only: the user has no Builder CanEdit (Epic 80427), or another
 * user holds the draft lock. Read by the flow, the canvas editor and every per-type panel, so a
 * control deep in a panel doesn't need the flag drilled through each layer. The API enforces the
 * same rule on its side — this only stops the UI offering what would be refused.
 */
const WorkflowReadOnlyContext = createContext(false);

export const WorkflowReadOnlyProvider = WorkflowReadOnlyContext.Provider;

export const useWorkflowReadOnly = () => useContext(WorkflowReadOnlyContext);
